import {
    generateDetailedHealthData,
    generateDevice,
    generateDeviceConsumptionResult,
    generateDeviceLastReading,
} from 'helpers/testing';
import { rest } from 'msw';

export const handlers = [
    rest.post(
        `${process.env.REACT_APP_NAPI_URL}/device-search`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    total: 1,
                    aggregations: {},
                    results: [generateDevice()],
                })
            );
        }
    ),
    rest.get(`${process.env.REACT_APP_NAPI_URL}/devices`, (req, res, ctx) => {
        return res(ctx.status(200), ctx.json(generateDevice()));
    }),
    rest.get(
        `${process.env.REACT_APP_NAPI_URL}/devices/:deviceId/readings-paginated`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    data: generateDeviceLastReading(
                        new Date().getTime() - 1000
                    ),
                })
            );
        }
    ),
    rest.get(
        `${process.env.REACT_APP_NAPI_URL}/devices/:deviceId/consumption`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    data: generateDeviceConsumptionResult(),
                })
            );
        }
    ),
    rest.get(
        `${process.env.REACT_APP_NAPI_URL}/devices/:deviceId/health`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    data: generateDetailedHealthData(),
                })
            );
        }
    ),
];
